import { useEffect, useState } from 'react';

/**
 * Returns `true` once the component has mounted on the client (i.e. after React hydration
 * has finished attaching event handlers). Returns `false` during SSR and on the first
 * client render so it matches the server-rendered output and avoids hydration mismatches.
 *
 * Primary use case: gating interactive controls (`disabled={!isHydrated}`) on SSR pages
 * so that Playwright (or fast users) can't trigger native-element default actions
 * before React has wired up the corresponding handlers.
 *
 * Background: https://github.com/microsoft/playwright/issues/27759
 */
export function useIsHydrated(): boolean {
    const [hydrated, setHydrated] = useState(false);
    useEffect(() => {
        setHydrated(true);
    }, []);
    return hydrated;
}
